/* Helper function to convert RGB to HEX */
import { PipelinePhaseCategory, ReferralStatus } from '@/api/types'

export function rgbToHex(r: number, g: number, b: number): string {
    const hexR = r.toString(16).padStart(2, '0')
    const hexG = g.toString(16).padStart(2, '0')
    const hexB = b.toString(16).padStart(2, '0')
    return `#${hexR}${hexG}${hexB}`
}

/* Helper function to convert HEX to RGB (taken from velocity-animate) */
export function hexToRgb(hex): [number, number, number] {
    const shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    const longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i
    let rgbParts

    hex = hex.replace(shortformRegex, (m, r, g, b) => {
        return r + r + g + g + b + b
    })

    rgbParts = longformRegex.exec(hex)

    return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0]
}

export function getColorForPhaseCategory(category: PipelinePhaseCategory, opacity: number = 1): string {
    switch (category) {
        case PipelinePhaseCategory.ENTRY:    return `rgba(19, 210, 197, ${opacity})`
        case PipelinePhaseCategory.APPROACH: return `rgba(247, 131, 35, ${opacity})`
        case PipelinePhaseCategory.DECISION: return `rgba(66, 153, 225, ${opacity})`
    }
}

export function getColorForStatus(status: string, opacity: number = 1): string {
    switch (status) {
        case ReferralStatus.OPEN:        return `rgba(96, 96, 96, ${opacity})`
        case ReferralStatus.NEW:         return `rgba(19, 210, 197, ${opacity})`
        case ReferralStatus.UNREACHABLE: return `rgba(235, 89, 140, ${opacity})`
        case ReferralStatus.PENDING:     return `rgba(247, 131, 35, ${opacity})`
        case ReferralStatus.APPOINTMENT: return `rgba(66, 153, 225, ${opacity})`
        case ReferralStatus.PROPOSAL:    return `rgba(145, 105, 226, ${opacity})`
        case ReferralStatus.ON_HOLD:     return `rgba(231, 220, 30, ${opacity})`
        case ReferralStatus.SUCCESSFUL:  return `rgba(0, 163, 137, ${opacity})`
        case ReferralStatus.CLOSED:      return `rgba(222, 64, 119, ${opacity})`
        case ReferralStatus.PROCESSED:   return `rgba(96, 96, 96, ${opacity})`
        default:                         return `rgba(169, 50, 38, ${opacity})`
    }
}
